import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Alert, Box, Button, CircularProgress, FormHelperText, InputLabel } from "@mui/material";
import MkAutoComplete from "../../../app/assets/theme/MkAutoComplete";
import { getGiftProducts } from "../../../app/hooks";

export default function GiftProductSelect({ product, onChange, error }) {
    const token = useSelector((state) => state.loginInfo.token);
    const [products, setProducts] = useState([]);
    const [status, setStatus] = useState("loading");
    const [attempt, setAttempt] = useState(0);
    useEffect(() => {
        const controller = new AbortController();
        setStatus("loading");
        getGiftProducts({ token, signal: controller.signal })
            .then((items) => {
                if (!controller.signal.aborted) {
                    setProducts(items);
                    setStatus("ready");
                }
            })
            .catch(() => { if (!controller.signal.aborted) setStatus("error"); });
        return () => controller.abort();
    }, [token, attempt]);
    const missing = product && !products.some((item) => String(item.id) === String(product.id));
    const options = missing ? [product, ...products] : products;
    return <Box>
        <InputLabel htmlFor="gift-product" sx={{ mb: 1, fontSize: "14.5px" }}>Bahozay Product</InputLabel>
        <MkAutoComplete
            id="gift-product"
            fullWidth
            placeholder={status === "loading" ? "Loading products..." : "Select Bahozay Product"}
            options={options}
            value={product}
            loading={status === "loading"}
            inputEndAdornment={status === "loading" ? (
                <CircularProgress
                    size={18}
                    aria-label="Loading products"
                    // Reserve space for the dropdown and clear buttons (7 = 56px).
                    sx={{ mr: 7, flexShrink: 0 }}
                />
            ) : null}
            getOptionLabel={(item) => item.nameMyanmar || item.name || `Product ${item.id}`}
            isOptionEqualToValue={(a, b) => String(a.id) === String(b.id)}
            onChange={(_, value) => onChange(value)}
        />
        {error && <FormHelperText error>{error}</FormHelperText>}
        {status === "error" && <Alert severity="error" action={<Button onClick={() => setAttempt(attempt + 1)}>Retry</Button>}>Unable to load Bahozay products.</Alert>}
        {status === "ready" && products.length === 0 && <Alert severity="info">No gift products are currently available.</Alert>}
        {status === "ready" && missing && <Alert severity="warning">This saved product is no longer available for new selections.</Alert>}

    </Box>;
}
